import { render } from "./ComponentNotificationsBell.vue?vue&type=template&id=36b458c0&scoped=true"
import script from "./ComponentNotificationsBell.vue?vue&type=script&lang=js"
export * from "./ComponentNotificationsBell.vue?vue&type=script&lang=js"

import "./ComponentNotificationsBell.vue?vue&type=style&index=0&id=36b458c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b458c0"]])

export default __exports__